import { lazy, Suspense, useState } from 'react'

import { composeClasses } from '@/utils/compose-classes'
import Dropdown from '../../../dropdown'
import Text from '../../../text/Text'
import Skeleton from '../../../skeleton/Skeleton'
import { MdOutlineExpandMore, MdOutlineExpandLess } from 'react-icons/md'

const Codes = lazy(() => import('./Codes'))

export interface ICode {
  phoneCode: string
  flag: string
  countryName: string
}
export interface PhoneCodeSelectorProps {
  phoneCode: string
  flag: string
  countryName: string
}

export interface CodesControllerProps {
  selectedCode: string
  disabled?: boolean
  onPhoneCodeChange?: (phoneCode: string) => void
  isResponsive?: boolean
  setSelectedCode: (code: string, country?: string) => void
  focusInput: () => void
}

export const PhoneCodesController = ({
  selectedCode,
  disabled,
  isResponsive = true,
  setSelectedCode,
  onPhoneCodeChange,
  focusInput
}: CodesControllerProps) => {
  const [showingCodes, setShowingCodes] = useState(false)
  return (
    <div className="absolute left-4">
      <Dropdown
        positionX={15}
        isResponsive={isResponsive}
        onClose={() => {
          setShowingCodes(false)
        }}
        isOpen={disabled ? false : showingCodes}
        setIsOpen={(value) => {
          setShowingCodes(value)
        }}
      >
        <Dropdown.Trigger>
          <button
            type="button"
            disabled={disabled}
            className="w-auto flex gap-1 items-center justify-center max-w-fit"
          >
            <Text
              className={composeClasses(
                'text-body-m text-tertiary-input truncate appear',
                disabled && '!text-button-primary-disabled'
              )}
            >
              {selectedCode}
            </Text>
            {showingCodes ? (
              <MdOutlineExpandMore
                className={composeClasses(
                  disabled && '!text-button-primary-disabled',
                  'text-[12px] text-primary transition-all duration-150'
                )}
              />
            ) : (
              <MdOutlineExpandLess
                className={composeClasses(
                  disabled && '!text-button-primary-disabled',
                  'text-[12px] text-primary transition-all duration-150'
                )}
              />
            )}
          </button>
        </Dropdown.Trigger>
        <Dropdown.Menu
          buttomSheetClassName="max-h-[50vh] w-full ui-kit-scrollbar bg-surface-white shadow-x1 border border-button-primary-disabled rounded-lg grid grid-cols-1 gap-2 min-w-[300px] max-h-[18.75rem] transition-all duration-300 overflow-y-auto"
          className="w-full ui-kit-scrollbar bg-surface-white shadow-x1 border border-button-primary-disabled rounded-lg grid grid-cols-1 gap-2 min-w-[300px] max-h-[18.75rem] transition-all duration-300 overflow-y-auto"
        >
          {showingCodes && (
            <Suspense
              fallback={
                <>
                  {[1, 2, 3].map((item) => (
                    <Skeleton
                      key={item}
                      width="w-full"
                      height="h-[28px]"
                      rounded="rounded-none"
                    />
                  ))}
                </>
              }
            >
              <Codes
                onPhoneCodeChange={onPhoneCodeChange}
                focusInput={focusInput}
                selectedCode={selectedCode}
                setSelectedCode={setSelectedCode}
                setShowingCodes={setShowingCodes}
              />
            </Suspense>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default PhoneCodesController
